// Tracks in-flight operations that should show the single global loading bar
// just below the top navigation bar. Most entries are mutating API requests
// (create / update / delete), but foreground page refreshes can opt in too.
//
// The apiClient increments on a write request start and decrements on
// completion (success or failure). UI subscribes via subscribeMutationActivity
// and reads the current count with getActiveMutationCount.

let activeCount = 0;
const listeners = new Set();

const notify = () => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch {
      // a misbehaving listener must not break request bookkeeping
    }
  });
};

export const beginGlobalLoading = () => {
  activeCount += 1;
  notify();
};

export const endGlobalLoading = () => {
  // Guard against underflow if begin/end ever get unbalanced.
  activeCount = Math.max(0, activeCount - 1);
  notify();
};

export const beginMutation = beginGlobalLoading;

export const endMutation = endGlobalLoading;

export const getActiveGlobalLoadingCount = () => activeCount;

export const getActiveMutationCount = getActiveGlobalLoadingCount;

export const isMutating = () => activeCount > 0;

export const subscribeGlobalLoadingActivity = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const subscribeMutationActivity = subscribeGlobalLoadingActivity;
